import DraggableItemMobile from './component'

export default DraggableItemMobile
